import React from "react";
import LoginModule from "../../modules/LoginModule";

const LoginPage = () => {
  return <LoginModule />;
};

export default LoginPage;
